import { memo } from "react";
import { useTypedSelector } from "hooks";
import { OnboardingApplicationStatus } from "consts/onboarding";
import useActions from "features/onboarding/useActions";
import { selectIsApplicationsLoading } from "features/onboarding/selectors";
import useSendApplicationDecision from "features/onboarding/useSendApplicationDecision";
import { ReviewableInput } from "ui/widgets/Input";
import { Action, useApplicationTableResourceContext } from "../ApplicationTableResourceProvider";

const RejectApplication = () => {
    const { context, onClose } = useApplicationTableResourceContext();

    const {
        isLoading,
        sendApplicationDecision
    } = useSendApplicationDecision();

    const isApplicationsLoading = useTypedSelector(selectIsApplicationsLoading);

    const { updateApplication } = useActions();

    const handleRejectApplication = (reason?: ReviewableInput.Reason) => {
        const params = {
            userId: context!.row.userId,
        };

        const [request] = updateApplication({
            ...params,
            status: OnboardingApplicationStatus.Rejected,
            rejectReason: reason?.notes
        });

        return request
            .then(() => sendApplicationDecision(params))
            .then(onClose);
    };

    return (
        <ReviewableInput.RejectDialog
            isProcessing={isLoading || isApplicationsLoading}
            isOpen={Object.is(context?.action, Action.RejectApplication)}
            renderLabel={() => `"${context?.row.companyName}"`}
            onConfirm={handleRejectApplication}
            onClose={onClose}
        />
    );
};

export default memo(RejectApplication);
